/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Meta_Sitename1Inputs */

const ja_playdata_meta_sitename1 = /** @type {(inputs: Playdata_Meta_Sitename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA`)
};

const en_playdata_meta_sitename1 = /** @type {(inputs: Playdata_Meta_Sitename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA`)
};

/**
* | output |
* | --- |
* | "PLAYDATA" |
*
* @param {Playdata_Meta_Sitename1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_meta_sitename1 = /** @type {((inputs?: Playdata_Meta_Sitename1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Meta_Sitename1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_meta_sitename1(inputs)
	return en_playdata_meta_sitename1(inputs)
});
export { playdata_meta_sitename1 as "playdata_meta_siteName" }